import React, { useState, useEffect, useCallback } from 'react';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import AddIcon from '@material-ui/icons/Add';
import { useDispatch, useSelector } from 'react-redux';
import SideBarListStyles from '../../styles/SideBarListStyle';
import {
  showProgress,
  getJourneyID,
  getJourneyDetails,
  getCapstoneDetails,
} from '../../redux/actions/DealershipActions';
import ShowProgress from '../ui/Backdrop';
import FloatButton from './FloatButton';
import RoleMapping from '../journey/RoleMapping';
import Service from '../../apis/service';
import { apiEndpoints } from '../../constants/apiEndpoints';
import JourneyAddNewPopup from '../journey/components/JourneyAddNewPopup';
import useFetchData from '../journey/hooks/useFetchData';
import ReactInfiniteScroll from '../common/ReactInfiniteScroll';

export default function SelectedListItem({ filterArray, value }) {
  const classes = SideBarListStyles();
  const journeyDetails = useSelector((state) => state.JourneyDetails.journeydetails);
  const { fetchJourneysList } = useFetchData();
  const myRef = filterArray?.reduce((acc, val) => {
    acc[val.id] = React.createRef();
    return acc;
  }, {});

  const [selectedIndex, setSelectedIndex] = React.useState();
  const [openRoleMaping, setOpenRoleMaping] = React.useState(false);
  const [isAddnewJourneyPopupOpen, setIsAddnewJourneyPopupOpen] = useState(false);
  const [isEditJourneyPopupOpen, setEditJourneyPopupOpen] = useState(false);
  const floatValue = value === undefined ? 0 : value;
  const dispatch = useDispatch();
  const journeyId = useSelector((state) => state.getJourneyID);
  const handleEditIconClick = () => {
    setEditJourneyPopupOpen(true);
  };
  const closeEditJourney = () => {
    setEditJourneyPopupOpen(false);
  };
  const handleCloseJourneyRoleMaping = () => {
    setOpenRoleMaping(false);
  };
  const handleListItemClick = useCallback(
    async (event, index) => {
      setSelectedIndex(index);
      dispatch(showProgress(true));
      await Service.get(apiEndpoints.JOURNEY_BY_ID.replace('ID', index), '')
        .then((response) => {
          if (response !== undefined) {
            dispatch(getJourneyID(index));
            dispatch(getJourneyDetails('updateJourneyDetails', response));
            if (response.levels?.length === 0) {
              dispatch(getCapstoneDetails('delete', []));
            }
            dispatch(showProgress(false));
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    [dispatch],
  );

  useEffect(() => {
    fetchJourneysList(handleListItemClick);
  }, [fetchJourneysList, handleListItemClick]);
  useEffect(() => {
    if (journeyId && myRef)
      myRef[journeyId]?.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
  }, [journeyId, myRef]);

  const fabs = [
    {
      color: 'primary',
      className: classes.fab,
      icon: <AddIcon />,
      label: 'Add',
    },
    {
      color: 'primary',
      className: classes.fab,
      icon: <AddIcon />,
      label: 'Add',
    },
  ];

  const addNewJourney = () => {
    setIsAddnewJourneyPopupOpen(true);
  };

  const closeAddNewJourney = () => {
    setIsAddnewJourneyPopupOpen(false);
  };
  const renderJourneyItem = (data) => {
    const index = data.id;
    return (
      <div key={data.id} className={selectedIndex === index ? classes.highlightItem : ''} style={{ width: '100%' }}>
        <ListItem
          id={`list_id_${data.id}`}
          key={data.id}
          ref={myRef[data.id]}
          button
          selected={selectedIndex === index}
          className={classes.listStyling}
          onClick={(event) => handleListItemClick(event, index)}
        >
          <ListItemText
            primary={
              <div>
                <p
                  className={`
                          ${selectedIndex === index ? classes.listTextSelected : classes.listTextNonSelected}
                        `}
                >
                  {data.title}
                </p>
              </div>
            }
            secondary={
              <div>
                <div className={selectedIndex === index ? classes.listSubTextSelected : classes.listSubTextNonSelected}>
                  <div className={classes.listSubTextJustify}>
                    <div className={classes.listItemId}>ID: {data?.id}</div>
                  </div>
                </div>
              </div>
            }
          />
        </ListItem>
      </div>
    );
  };

  return (
    <div className={classes.root}>
      <ReactInfiniteScroll size={20} data={filterArray || []} height="54vh" renderItem={renderJourneyItem} />
      <FloatButton fabs={fabs} value={floatValue} mainTabID={0} onaddNewJourney={addNewJourney} />
      {openRoleMaping && (
        <RoleMapping
          open
          type="journey"
          journeyPop={handleEditIconClick}
          edit={false}
          id={journeyId}
          handleClick={(id) => {
            handleListItemClick(0, id);
          }}
          close={handleCloseJourneyRoleMaping}
        />
      )}
      {isAddnewJourneyPopupOpen && (
        <JourneyAddNewPopup add open close={closeAddNewJourney} setSelectedIndex={setSelectedIndex} myRef={myRef} />
      )}
      {isEditJourneyPopupOpen && (
        <JourneyAddNewPopup add={false} open close={closeEditJourney} journeyId={journeyDetails?.id} />
      )}

      {<ShowProgress />}
    </div>
  );
}
